<template>
  <div>
    <h3 class="text-white text-[30px] lg:text-[80px] leading-[30px] lg:leading-[80px] font-[500] mb-[32px] lg:mb-[60px]">Show me <br> case studies for...</h3>
    <div class="flex flex-col gap-[10px] lg:gap-[20px]">
      <!-- Filter buttons will go here -->
      <div v-for="(row, rowIndex) in filtersMobile" :key="rowIndex" class="flex lg:hidden flex-wrap gap-[10px] lg:gap-[20px]">
        <button
          v-for="filter in row"
          :key="filter"
          type="button"
          class="topic-button"
          :class="{ active: isFilterSelected(filter) }"
          @click="toggleFilter(filter)"
        >
          {{ filter }}
        </button>
      </div>
      <div v-for="(row, rowIndex) in filters" :key="rowIndex" class="hidden lg:flex flex-wrap gap-[10px] lg:gap-[20px]">
        <button
          v-for="filter in row"
          :key="filter"
          type="button"
          class="topic-button"
          :class="{ active: isFilterSelected(filter) }"
          @click="toggleFilter(filter)"
        >
          {{ filter }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { defineEmits } from 'vue';

const selectedFilters = ref<string[]>([]);
const emits = defineEmits(['filters-updated']);

const filters = [
  ["Static Ads", "Motion Ads", "Creator Content Ads","Data"],
  ["Performance Marketing", "Pay Per Click", "Google Ads"],
  ["Organic Social", "Conversion Rate Optimisation", "Landing Pages"]
];
const filtersMobile = [
  ["Static Ads", "Motion Ads", "Creator Content Ads", "Data", "Performance Marketing", "Pay Per Click", "Google Ads", "Organic Social", "Conversion Rate Optimisation", "Landing Pages"],
];

const toggleFilter = (filter: string) => {
  const index = selectedFilters.value.indexOf(filter);
  if (index === -1) {
    selectedFilters.value.push(filter);
  } else {
    selectedFilters.value.splice(index, 1);
  }
  emits('filters-updated', selectedFilters.value);
};

const isFilterSelected = (filter: string) => {
  return selectedFilters.value.includes(filter);
};

</script>

<style lang="scss" scoped>
.topic-button {
  position: relative;
  border: 1px solid #fff;
  border-radius: 9999px;
  padding: 0.5rem 1rem;
  font-size: 11px;
  line-height: 1.25rem;
  font-weight: 500;
  color: #fff;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  z-index: 1;
}

/* Remove the white border on hover */
.topic-button:hover {
  border-color: transparent;
}

.topic-button::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px; /* simulate the border width */
  background: linear-gradient(50.34deg, #52DA75 39.22%, #3CDFF8 145.92%);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;
  z-index: 0;
}

.topic-button:hover::before {
  opacity: 1;
}

.topic-button.active {
  background: linear-gradient(50.34deg, #52DA75 39.22%, #3CDFF8 145.92%);
  border-color: transparent;
  color: black;
}
</style>
